import { render } from "./AttachmentComponent.vue?vue&type=template&id=230cdd26"
import script from "./AttachmentComponent.vue?vue&type=script&lang=js"
export * from "./AttachmentComponent.vue?vue&type=script&lang=js"

import "./AttachmentComponent.vue?vue&type=style&index=0&id=230cdd26&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__